import { NgModule } from '@angular/core';
import { AlertsModule } from './alerts/alerts';
import { AppUpdatesModule } from './app-updates/app-updates.module';
import { CarrierModule } from './carrier/carrier';
import { ConfirmModule } from './confirm/confirm';
import { AffixModule } from './directives/affix';
import { AuthorizeModule } from './directives/authorize';
import { IconModule } from './icon/icon';
import { LoadingShadeModule } from './loading-shade/loading-shade';
import { NavigationModule } from './navigation/navigation';
import { NoseNumberModule } from './nose-number/nose-number';
import { PipesModule } from './pipes/pipes.module';
import { SaveButtonModule } from './save-button/save-button';
import { RouteParamsModule } from './services/route-params';
import { SharePointModule } from './services/share-point';
import { UserModule } from './services/user';
import { SideTabModule } from './sidetab/sidetab';
import { SortLinkModule } from './sort-link/sort-link';
import { StationSearchModule } from './station-search/station-search';
import { UserSearchModule } from './user-search/user-search';

const modules = [
  NavigationModule,
  AppUpdatesModule,
  SaveButtonModule,
  IconModule,
  SharePointModule,
  SideTabModule,
  UserModule,
  AuthorizeModule,
  StationSearchModule,
  SortLinkModule,
  AffixModule,
  ConfirmModule,
  CarrierModule,
  PipesModule,
  LoadingShadeModule,
  RouteParamsModule,
  AlertsModule,
  NoseNumberModule,
  UserSearchModule,
];

@NgModule({
  imports: modules,
  exports: modules,
  declarations: [],
})
export class NgPartnersModule { }
